module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/built-drawing/built-drawing-grid/built-drawing-grid.component.css
// module id = ./src/app/planning/built-drawing/built-drawing-grid/built-drawing-grid.component.css
// module chunks = main